import { Box, Flex } from '@retriever-ui/react'
import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import RadioInput from '../../../../../components/inputs/radio-themed'
import { Typography } from '../../../../../components/typograph'
import * as S from './styled'

const ParkingField = ({ register, getValues, setValue }) => {
  const { t } = useTranslation('search-filter-form')
  const beforeState = useRef(null)

  const handleUnCheck = (e) => {
    const { value } = e.target

    if (value == beforeState.current) {
      setValue('parkingSpaces', null)
      beforeState.current = null
    } else
      beforeState.current = typeof value === 'string' ? Number(value) : value
  }

  React.useEffect(() => {
    beforeState.current = getValues().parkingSpaces
  }, [])

  return (
    <S.ContentField>
      <Box>
        <Typography title variant="extraSmall" weight="bold">
          {t('search-filter-form:PARKING')}
        </Typography>
      </Box>
      <Flex mTop="24px" gap="8px">
        <RadioInput
          asButton
          labelRadio={t('search-filter-form:NO_PARKING')}
          index="1"
          value={undefined}
          name="parkingSpaces"
          ref={register}
          onClick={handleUnCheck}
        />
        <RadioInput
          asButton
          labelRadio="1"
          index="2"
          value={1}
          name="parkingSpaces"
          ref={register}
          onClick={handleUnCheck}
        />
        <RadioInput
          asButton
          labelRadio="2"
          index="3"
          value={2}
          name="parkingSpaces"
          ref={register}
          onClick={handleUnCheck}
        />
      </Flex>
    </S.ContentField>
  )
}

export default ParkingField
